module.exports = __webpack_public_path__ + "img/lc03.cd21b95b.png";